export default __webpack_public_path__ + "static/media/clock-icon.e54ec641.svg";